import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import React from "react";
import PelvicSenseTestimonialCard from "./PelvicSenseTestimonialCard";
import Robin from "../img/PelvicSenseReview1.png";
import Victoria from "../img/PelvicSenseReview2.png";
import Marie from "../img/PelvicSenseReview3.png";
import PelvicTestimonialCardWithoutHover from "./PelvicTestimonialCardWithoutHover";

export const PelvicProgramBanner5 = ({ width }) => {
  return (
    <div className="pelvic-program-banner-5">
      <h3 className="text-al fs-32 text-center">
        <span
          className={
            width > 830
              ? "highlight-light-purple text-black fs-48-28"
              : "highlight-light-purple text-black mb-5 fs-48-28"
          }
        >
          Hear it from women who have been helped by<br className="desktop-view-hidden" />{" "} PelvicSense
        </span>
      </h3>
      <MDBRow className="p-sm-2 p-md-3 p-lg-5">
        <MDBCol sm="12" md="12" lg="4" className="my-3">
          {width > 830 ? (
            <PelvicSenseTestimonialCard
              text='"Since starting PelvicSense I’m able to move more freely. My chiropractor notices that my pelvis and spine are less twisted, and I actually forgot to bring my sitting cushion with me a few times! I love the Rewire audio guides as they help me feel super relaxed."'
              name="Robin M."
              image={Robin}
              altText="Robin"
              width={width}
            />
          ) : (
            <PelvicTestimonialCardWithoutHover
              text='"Since starting Pelvic Sense I’m able to move more freely. My chiropractor notices that my pelvis and spine are less twisted, and I actually forgot to bring my sitting cushion with me a few times! I love the Rewire audio guides as they help me feel super relaxed."'
              name="Robin M."
              image={Robin}
              altText="Robin"
              width={width}
            />
          )}
        </MDBCol>
        <MDBCol sm="12" md="12" lg="4" className="my-3">
          {width > 830 ? (
            <PelvicSenseTestimonialCard
              text='"Understanding the why of pain and what happens in the brain through Learn provided belief in healing. Rewire helped ease my pelvic-related anxiety. Move helped target my pelvic issues in a comfortable, non-threatening way."'
              name="Victoria W."
              image={Victoria}
              altText="Victoria"
              width={width}
            />
          ) : (
            <PelvicTestimonialCardWithoutHover
              text='"Understanding the why of pain and what happens in the brain through Learn provided belief in healing. Rewire helped ease my pelvic-related anxiety. Move helped target my pelvic issues in a comfortable, non-threatening way."'
              name="Victoria W."
              image={Victoria}
              altText="Victoria"
              width={width}
            />
          )}
        </MDBCol>
        <MDBCol sm="12" md="12" lg="4" className="my-3">
          {width > 830 ? (
            <PelvicSenseTestimonialCard
              text='"Thank you for putting together this course for people like me. I’m enjoying all the information you’ve shared as well as the Rewire and Move sections. I’m already experiencing an increase in the number of moments of feeling a reduction of pain! Just wanted to express my gratitude."'
              name="Marie C."
              image={Marie}
              altText="Marie"
              width={width}
            />
          ) : (
            <PelvicTestimonialCardWithoutHover
              text='"Thank you for putting together this course for people like me. I’m enjoying all the information you’ve shared as well as the Rewire and Move sections. I’m already experiencing an increase in the number of moments of feeling a reduction of pain! Just wanted to express my gratitude."'
              name="Marie C."
              image={Marie}
              altText="Marie"
              width={width}
            />
          )}
        </MDBCol>
      </MDBRow>
    </div>
  );
};
